// @flow
import React, { type ChildrenArray, type Element } from 'react';
import { usePropsValidation } from '../validation/runtime-checks/index.js';
import { Text } from '../Text.js';
import TabularData from '../TabularData.js';
import { CollapsibleInternal } from '../CollapsibleInternal.js';
import { types as t } from '../validation/runtime-checks/index.js';
import Image from '../Image.js';
import { ColumnInternal, RowInternal } from '../grid.js';
import DraftImage from '../DraftImage.js';
import { List } from '../List.js';
import Latex from '../Latex.js';
import { LatexTextAtom } from '../LatexTextAtom.js';

type Props = {|
  children: ChildrenArray<
    Element<
      | typeof Text
      | typeof Latex
      | typeof LatexTextAtom
      | typeof List
      | typeof TabularData
      | typeof Image
      | typeof DraftImage,
    >,
  >,
|};

export default function PTNConfusingConcepts(props: Props) {
  const { failedValidation } = usePropsValidation(props, PTNConfusingConcepts);
  if (failedValidation) return null;
  return (
    <CollapsibleInternal title="Confusing concepts">
      <RowInternal>
        <ColumnInternal fullWidth>{props.children}</ColumnInternal>
      </RowInternal>
    </CollapsibleInternal>
  );
}

PTNConfusingConcepts.spec = {
  children: t.childrenArray(
    t.unionOfTypes(
      t.elementType(Text),
      t.elementType(Latex),
      t.elementType(LatexTextAtom),
      t.elementType(List),
      t.elementType(TabularData),
      t.elementType(Image),
      t.elementType(DraftImage),
    ),
  ),
};
